// extracted by css-extract-rspack-plugin
export default {"root":"LineDecorator-module__root___ZH4dC","border":"LineDecorator-module__border___FlWsB"};